import React, {useEffect} from "react";
import isAnError from "../../model/misc";
import {postRaw} from "../../utils/communication";
import {getCookie} from "../../utils/crypto";
import {User, userRoles} from "../../model/user";
import {Link, Navigate} from "react-router-dom";
import {Simulate} from "react-dom/test-utils";
import load = Simulate.load;

export default function UserHome() {
    const [loading, setLoading] = React.useState<boolean>(true),
        [user, setUser] = React.useState<User | null>(null),
        [needsRedirect, setNeedsRedirect] = React.useState<boolean>(false);

    useEffect(() => {
        document.title = "User - Hoarfroster";

        (async () => {
            let response = await postRaw("/user/info", {}, {});

            if (response.code !== 200) {
                setNeedsRedirect(true);
            } else {
                setUser(response.data as User);
            }

            setLoading(false);
        })();
    }, []);

    const UserDetail = () => {
        if(loading) {
            return (<p>Loading...</p>);
        }

        if (!needsRedirect) {
            return (
                <div>
                    <h1>{user?.name}</h1>
                    <p>Email {user?.email}</p>
                    <p>Role {userRoles[user?.role ?? 0]}</p>

                    <p className="text-8 text-sm">PublicID {user?.publicId}</p>
                    <p className="text-8 text-sm">Created {user?.createdAt.toString()}</p>
                </div>
            )
        } else {
            return (<Navigate to="/user/sign-in"/>);
        }
    }

    return (
        <main>
            <div className="container">
                <div className="content space-y-4">
                    <UserDetail />

                    <UserHomeLinks user={user}/>
                </div>
            </div>
        </main>
    );
}

const UserHomeLinks = ({user}: { user: User | null }) => {
    if (user?.role === 3) {
        return (
            <div>
                <h2>Quick Links</h2>
                <Link to="/dashboard">Dashboard</Link>
            </div>
        )
    } else {
        return (<></>);
    }
}